import useNudge from "@app/analytics/MeetingReport/hooks/useNudge";
import useTranscriptStore from "@app/analytics/MeetingReport/stores/transcript";

import Nudge from "@rui/Nudge";

const MeetingReportNudge = () => {
  const [nudge, setNudge] = useNudge("main");

  const { playbackParagraphId, setActiveItem } = useTranscriptStore(
    (state) => ({
      playbackParagraphId: state.playbackParagraphId,
      setActiveItem: state.setActiveItem,
    })
  );

  if (nudge == null) return null;

  const { tab: _, ...nudgeProps } = nudge;

  // right now this component assumes that the only nudge that could possibly show here is the
  // transcript auto-follow nudge. if/when any other nudges need to be supported, the click handler
  // below will need to be abstracted out of this component
  const handleNudgeClick = () => {
    if (!playbackParagraphId) return;
    setActiveItem({ id: playbackParagraphId, type: "paragraph" });
    setNudge(null);
  };

  return <Nudge onClick={handleNudgeClick} {...nudgeProps} />;
};

export default MeetingReportNudge;
